// extracted by mini-css-extract-plugin
export default {"content":"uIT03t6I8xh91661Yzvw","iconWrapper":"Lq9mDb5P3jsDG8fMyPDc","isDanger":"q2HAV_xRMKvNr1uvfgxt","message":"V2Q9DGdrUpIjowBizEkq","small":"GG3R8YivrvaPg6y1gs1V"};